"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueSearchItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
/** Minimal venue payload for text / map search (no activity aggregates). */
class VenueSearchItemDto {}
exports.VenueSearchItemDto = VenueSearchItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSearchItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSearchItemDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSearchItemDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], VenueSearchItemDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchItemDto.prototype, "logoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'True when the venue has a custom/purchased logo.'
}), __metadata("design:type", Boolean)], VenueSearchItemDto.prototype, "isPartnerVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchItemDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchItemDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchItemDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchItemDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchItemDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchItemDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Distance from search center in meters (Haversine).'
}), __metadata("design:type", Number)], VenueSearchItemDto.prototype, "distanceToCenter", void 0);
//# sourceMappingURL=VenueSearchItem.dto.js.map